import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AgruparLineasER } from "../../Actions/ActionEstadoResultados";
import { GetKey, GetPeriodo } from "../../Actions/GetContainer";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";
import { useBoxProyecciones } from "./useBoxProyecciones";
import { BoxStructure } from "./BoxStructure";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { LoaderScreen } from "../../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const ProyeccionesVentasScreen = () => {
  const [boxstate, setBoxState, updateBoxState] = useBoxProyecciones();
  const history = useHistory();
  const location = useLocation();
  const [primeraVez, setPrimeraVez] = useState(true);
  const sucursales = location.state?.sucursales;
  const idSucursalUnicos = [
    ...new Map(
      sucursales == undefined || sucursales === null || sucursales.length === 0
        ? []
        : sucursales.map((item) => [
            item.idsucursal,
            { idsucursal: item.idsucursal },
          ]),
    ).values(),
  ];
  // console.log(sucursales)
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [titulo, setTitulo] = useState({
    periodoinicio: "0",
    periodofin: "0",
    ejercicioinicio: "0",
    ejerciciofin: "0",
    comparacion: "",
  });
  const [state, setState] = useState({
    data: [],
  });

  const onHome = () => {
    history.push("/Finanzas/Main");
  };

  useEffect(() => {
    BoxClick();
  }, []);

  useEffect(() => {
    setPrimeraVez(false);
  }, []);

  const BoxClick = () => {
    // console.log(boxstate)
    setLoader({ ...loader, mostrar: true });
    return new Promise((res, req) => {
      if (boxstate.ejercicio == "0") {
        req("Favor de indicar el ejercicio");
        return;
      }
      if (boxstate.mesInicio == "0") {
        req("Favor de indicar el mes de inicio");
        return;
      }
      if (boxstate.mesFin == "0") {
        req("Favor de indicar el mes fin");
        return;
      }
      if (Number(boxstate.mesInicio) > Number(boxstate.mesFin)) {
        req("La fecha de inicio no puede ser mayor a la fecha fin");
        return;
      }
      const post = {
        ejercicio: Number(boxstate.ejercicioinicio),
        ejercicioant: Number(boxstate.ejerciciofin),
        comparar: boxstate.comparacion,
        Periodo: GetPeriodo(boxstate.periodoinicio, boxstate.periodofin),
        departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
        sucursal:
          primeraVez ||
          boxstate?.pv?.sucursal === "" ||
          boxstate?.pv?.sucursal === 0 ||
          boxstate?.pv?.sucursal === "0" ||
          boxstate?.pv?.sucursal === undefined ||
          (Array.isArray(boxstate?.pv?.sucursal) &&
            boxstate.pv.sucursal.length === 0)
            ? GetKey(idSucursalUnicos, ["idsucursal"])
            : GetKey(boxstate.pv.sucursal, ["idsucursal"]),
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
      };
      request
        .post("ProyeccionesVenta/Obtener", post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          var newarray = [];
          var grupos = AgruparLineasER(result);
          grupos.forEach((item) => {
            newarray = [
              ...newarray,
              {
                depto: item,
                data: result.filter((x) => x.departamento == item),
              },
            ];
          });
          setState({
            ...state,
            data: newarray,
          });
          setTitulo({
            ...titulo,
            periodoinicio: boxstate.periodoinicio,
            periodofin: boxstate.periodofin,
            ejercicioinicio: boxstate.ejercicioinicio,
            ejerciciofin: boxstate.ejerciciofin,
            comparacion: boxstate.comparacion === "R" ? "REAL" : "PROYECTADO",
          });
          res("");
        })
        .catch((err) => {
          console.log(err);
          setLoader({ ...loader, mostrar: false });
          req(JSON.stringify(err));
        });
    });
  };
  const imprimirexcelflujo = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      ejercicio: Number(boxstate.ejercicio),
      Periodo: GetPeriodo(boxstate.mesInicio, boxstate.mesFin),
      departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
      sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
      adr: GetKey(boxstate.pv.adr, ["idadr"]),
      subtitulo: SubTitulo(),
      region: boxstate.titulosucursal,
      subdepartamento: boxstate.titulodepartamento,
    };
    request
      .post("AutorizacionPG/ProyeccionVentasExcel", post)
      .then(({ documento, filename }) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((err) => {
        setLoader({ ...loader, mostrar: false });
      });
  };
  const imprimirexcelComparativo = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      ejercicio: Number(boxstate.ejercicio),
      Periodo: GetPeriodo(boxstate.mesInicio, boxstate.mesFin),
      departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
      sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
      adr: GetKey(boxstate.pv.adr, ["idadr"]),
      subtitulo: SubTitulo(),
      region: boxstate.titulosucursal,
      subdepartamento: boxstate.titulodepartamento,
    };
    request
      .post("RevisionProyeccion/RevisionProyeccionVentasExcel", post)
      .then(({ documento, filename }) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((err) => {
        setLoader({ ...loader, mostrar: false });
      });
  };
  const SubTitulo = () => {
    if (titulo.ejercicioinicio === "0") return "";
    else {
      if (
        Number(titulo.periodoinicio) === Number(titulo.periodofin) &&
        Number(titulo.ejercicioinicio) === Number(titulo.ejerciciofin)
      ) {
        return `${GetMonthNameByNumber(titulo.periodoinicio).toUpperCase()} DEL ${titulo.ejercicioinicio}`;
      } else if (
        Number(titulo.periodoinicio) !== Number(titulo.periodofin) &&
        Number(titulo.ejercicioinicio) === Number(titulo.ejerciciofin)
      ) {
        return `DE ${GetMonthNameByNumber(titulo.periodoinicio).toUpperCase()} A ${GetMonthNameByNumber(titulo.periodofin).toUpperCase()} DEL ${titulo.ejercicioinicio}`;
      } else if (
        Number(titulo.periodoinicio) === Number(titulo.periodofin) &&
        Number(titulo.ejercicioinicio) !== Number(titulo.ejerciciofin)
      ) {
        return `${GetMonthNameByNumber(titulo.periodoinicio).toUpperCase()} DEL ${titulo.ejercicioinicio} CONTRA ${titulo.ejerciciofin}`;
      } else {
        return `DE ${GetMonthNameByNumber(titulo.periodoinicio).toUpperCase()} A ${GetMonthNameByNumber(titulo.periodofin).toUpperCase()} DEL ${titulo.ejercicioinicio} CONTRA  ${titulo.ejerciciofin}`;
      }
    }
  };
  // console.log(titulo)
  return (
    <PlantillaScreen
      titulo={`ESTADO DE RESULTADOS COMPARATIVO ${SubTitulo()}`}
      className={"proyecciones-ventas-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />

      <div className="proyecciones-ventas-contenedor-filtros">
        <div className="proyecciones-ventas-regresar" onClick={() => onHome()}>
          <ArrowBackIcon /> Regresar
        </div>
        <BoxStructure
          onBoxChange={setBoxState}
          boxState={boxstate}
          BoxClick={BoxClick}
          updateBoxState={updateBoxState}
          titulo_filtro={"FILTRO ESTADO DE RESULTADOS COMPARATIVO"}
          // titulo='Estado de Resultados Comparativo real vs proyeccion'
          // subtitulo={SubTitulo()}
          extrayear={3}
          sucursales={sucursales}
        ></BoxStructure>
      </div>

      {/* <div key='box-actions' className='box-actions'>
                <button className="excel" onClick={imprimirexcelflujo}>Flujo</button>
                <button className="excel" onClick={imprimirexcelComparativo}>Comparativo</button>
            </div> */}
      {state.data === undefined ||
      state.data === null ||
      state.data.length === 0 ? (
        <div>No existen datos para mostrar</div>
      ) : (
        <div
          id="comparativa-gastos-proyeccion-tipo"
          className="scroll-4"
          style={{ marginRight: 10 }}
        >
          <table
            className="table-informacion-estado-resultados"
            cellSpacing={0}
            id="tabla-sticky"
          >
            <thead>
              <tr className="tr-encabezado1">
                <th
                  className="bl sticky-col-h-30"
                  style={{ minWidth: "150px" }}
                >
                  CONCEPTO
                </th>
                <th className="bl sticky-col-h-30" style={{ minWidth: "80px" }}>
                  <div>{`PROYECCION ${titulo.ejercicioinicio}`}</div>
                </th>
                <th className="sticky-col-h-30" style={{ minWidth: "80px" }}>
                  %
                </th>
                <th className="bl sticky-col-h-30" style={{ minWidth: "80px" }}>
                  <div>{`${titulo.comparacion} ${titulo.ejerciciofin}`}</div>
                </th>
                <th className="sticky-col-h-30" style={{ minWidth: "80px" }}>
                  %
                </th>
                <th className="bl sticky-col-h-30" style={{ minWidth: "80px" }}>
                  <div>DIFERENCIA</div>
                </th>
                <th className="br sticky-col-h-30" style={{ minWidth: "80px" }}>
                  %
                </th>
              </tr>
            </thead>
            <tbody>
              {state.data.map((item) => (
                <>
                  <tr>
                    <td className="bl br depto-title" colSpan={7}>
                      {item.depto}
                    </td>
                  </tr>
                  {item.data.map((obj) => (
                    <tr>
                      <td className={`bl ${obj.clase}`}>{obj.concepto}</td>
                      <td className={`bl ta-right ${obj.clase} `}>
                        {FormatMoney(obj.importe, 2)}
                      </td>
                      <td className={`ta-right ${obj.clase}  pr-5`}>
                        {FormatMoney(obj.por, 2)} %
                      </td>
                      <td className={`bl ta-right ${obj.clase} `}>
                        {FormatMoney(obj.proyimporte, 2)}
                      </td>
                      <td className={`ta-right ${obj.clase} pr-5 `}>
                        {FormatMoney(obj.proypor, 2)} %
                      </td>
                      <td className={`bl ta-right ${obj.clase} `}>
                        {FormatMoney(obj.diffimporte, 2)}
                      </td>
                      <td className={`br ta-right ${obj.clase} pr-5 `}>
                        {FormatMoney(obj.diffpor, 2)} %{" "}
                      </td>
                    </tr>
                  ))}
                  <tr style={{ height: 20 }}></tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PlantillaScreen>
  );
};
